export const ErrorConfig: any = {
  // 网络错误
  netWorkError: {
    errorIcon: require('@/images/error/network.png'),
    errorText: '网络出错了～',
    errorBtn: '点击重试',
    errorBtnClick: () => {
      //返回重试
      history.go(-1);
    },
    title: '网络报错',
  },
  // 404页面
  not404: {
    errorIcon: require('@/images/error/network.png'),
    errorText: '页面没找到～',
    title: '404',
  },
  //活动已经结束
  activeEnd: {
    errorIcon: require('@/images/error/end.png'),
    errorText: '活动已结束，下次早点来哦',
  },
  // 暂无碎片明细
  emptyFragment: {
    errorIcon: require('@/images/error/empty.png'),
    errorText: '暂无碎片明细',
  },
};
